import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import { COMPANY_INFO } from '../data/mockData';

export default function NotFoundPage() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4 py-16">
      <SEO title="404 - Siden blev ikke fundet | K-TO Ventilationsteknik" />

      <div className="max-w-2xl w-full bg-white rounded-3xl p-8 sm:p-12 border border-slate-200 shadow-xl text-center space-y-6">
        <div className="w-20 h-20 bg-sky-100 text-sky-600 rounded-2xl flex items-center justify-center font-black text-3xl mx-auto shadow-inner">
          404
        </div>

        <h1 className="text-3xl font-extrabold text-slate-900 tracking-tight">
          Siden blev ikke fundet
        </h1>

        <p className="text-slate-600 text-sm leading-relaxed max-w-md mx-auto">
          Den side du leder efter findes desværre ikke eller er flyttet. Du kan benytte knapperne nedenfor til at finde det, du søger.
        </p>

        <div className="flex flex-wrap justify-center items-center gap-3 pt-4 text-xs font-bold uppercase tracking-wider">
          <Link
            to="/"
            className="bg-sky-600 hover:bg-sky-700 text-white px-5 py-3 rounded-xl transition-colors"
          >
            Gå til forsiden
          </Link>

          <Link
            to="/ydelser/service-og-ventilation"
            className="bg-slate-100 hover:bg-slate-200 text-slate-800 px-5 py-3 rounded-xl transition-colors"
          >
            Se ydelser
          </Link>

          <Link
            to="/galleri"
            className="bg-slate-100 hover:bg-slate-200 text-slate-800 px-5 py-3 rounded-xl transition-colors"
          >
            Se galleri
          </Link>

          <Link
            to="/kontakt"
            className="bg-slate-900 hover:bg-slate-800 text-white px-5 py-3 rounded-xl transition-colors"
          >
            Kontakt os
          </Link>
        </div>

        <div className="pt-6 border-t border-slate-100 text-xs text-slate-500">
          Har du brug for akut assistance? Ring til os på{' '}
          <a href={`tel:${COMPANY_INFO.phoneRaw}`} className="font-extrabold text-sky-600 hover:underline nowrap-contact">
            22 72 87 23
          </a>
        </div>
      </div>
    </div>
  );
}
